import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/shared/contants';
import { ApiServices } from 'src/app/shared/services/api.service';
import { DataService } from 'src/app/shared/services/data.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
  selector: 'app-accessories-details',
  templateUrl: './accessories-details.component.html',
  styleUrls: ['./accessories-details.component.scss']
})
export class AccessoriesDetailsComponent implements OnInit, OnDestroy {
  private subs = new Subscription();

  category = '';
  sku = '';
  id = '';

  addOn;

  isLoading = false;

  discountedPrice;

  trans = Constants.categoryTrans;

  specs = [];

  addOnQty: Array<number> = [];
  addOnCartTotalQty: Array<number> = [];
  warehouse_quantity:any = {};
  private cartItems: any[] = [];
  is_hide_cost:any = null;

  isCartProcessing = false;
  inventoryData:any = []

  constructor(
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiServices,
    private helperService: HelperService,
    private toastr: ToastrService,
  ) {
    this.is_hide_cost = localStorage.getItem("is_hide_cost")
    this.helperService.setPageTitle(activatedRoute.snapshot.data.title);
  }

  ngOnInit(): void {
    this.subs.add(
      this.activatedRoute.params.subscribe(params => {
        this.id = params.id;
        this.sku = params.sku;
        this.category = params.category;
        this.specs = this.helperService.categoryFieldsMapping(this.category);
        this.getAddOn();
      })
    );
  }

  getAddonByAccessory(accessory_id){
    let inventory_loader = document.querySelector(".inventory_loader") as HTMLElement;
    let inventory_table = document.querySelector(".inventory_table") as HTMLElement;
    inventory_table.style.display = "none";
    inventory_loader.classList.remove("d-none");
    inventory_loader.classList.add("d-flex");
    this.inventoryData = [];
    this.apiService.getAddonByAccessory(accessory_id).subscribe(
      response => {
        inventory_table.style.display = "block";
        inventory_loader.classList.remove("d-flex");
        inventory_loader.classList.add("d-none");
        this.inventoryData = response.data.inventory;
      }
    );
  }

  convertToTitleCase(specification_key:string) {
    specification_key = specification_key != null && specification_key != undefined ? specification_key : ''
    return specification_key
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  }

  setWarehouse(warehouse_id) {
    this.warehouse_quantity['warehouse_id'] = warehouse_id;
    this.warehouse_quantity['quantity'] = 1;
    this.warehouse_quantity['accessory'] = this.addOn.id;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getAddOn() {
    this.isLoading = true;
    this.apiService.getAddOnDetail(this.category, this.sku, +this.id).subscribe(res => {
      this.isLoading = false;
      this.addOn = res.data;

      if(this.addOn.price > this.addOn.discounted_price) {
        this.discountedPrice = this.addOn.discounted_price;
      }
    }, err => {
      this.isLoading = false;
    })
  }

  addEditQty(warehouseCode: string, warehouseId: number, warehouseTotalQty: number, addOnId: number, inventory: Array<any>, qty: number, eta_qty = 0): void {
    const index = `${addOnId}_${warehouseId}`;
    this.addOnCartTotalQty[addOnId] = 0;
    this.addOnQty[index] = qty;

    const allQtySum = eta_qty + warehouseTotalQty;

    if (qty > allQtySum) {
        this.toastr.error(`Invalid quantity. ${warehouseCode} has only ${allQtySum} quantity left.`, 'Error');
    } else if (qty < 0) {
        this.toastr.error(`(${warehouseCode}) Invalid quantity.`, 'Error');
    } else {
        let totalQty = 0;

        inventory.forEach(v => {
            const addOnQtyValue = this.addOnQty[`${addOnId}_${v.warehouse_id}`] || 0;
            totalQty += addOnQtyValue;
        });

        this.addOnCartTotalQty[addOnId] = totalQty;
    }
  }

  AddToCart(addOnId: number): void {

    let selectedQtyElm = document.querySelector(".quantity-field") as HTMLInputElement;
    let userQty = parseInt(selectedQtyElm.value);

    let item = {add_on_id: addOnId, quantity: userQty}
    if (addOnId === this.warehouse_quantity['accessory']) {
      delete this.warehouse_quantity["accessory"]
      item["warehouse_qunatity"] = [this.warehouse_quantity]
    }

    if (userQty > this.addOn.total_quantity) {
      this.toastr.error(`Invalid Quantity, ${addOnId} has only ${this.addOn.total_quantity} quantity left`, 'Error');
    } else {
      const session_id = localStorage.getItem('session_id');
      const data = {
        session_id,
        type: "addon_added_to_cart_directly",
        items: [item],
      };

      this.subs.add(
        this.apiService.addToCart(data).subscribe(
          response => {
            if (response.status) {
              this.apiService.getCart().subscribe(response => {
                if (response.status) {
                  this.dataService.setCartData(response);
                }
              });
              this.toastr.success(response.message, 'Success');
            }
          }, error => {
            this.toastr.error(error.error.message, 'Error');
          }
        )
      );
    }
  }


  quantity: number = 1;
  minQuantity: number = 1;

  incrementQuantity() {
    this.quantity++;
  }

  decrementQuantity() {
    if (this.quantity > this.minQuantity) {
      this.quantity--;
    }
  }
}
